import { render, staticRenderFns } from "./SerieDetail.vue?vue&type=template&id=553c8988&"
import script from "./SerieDetail.vue?vue&type=script&lang=js&"
export * from "./SerieDetail.vue?vue&type=script&lang=js&"
import style0 from "./SerieDetail.vue?vue&type=style&index=0&id=553c8988&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports